<template>
  <div>
    <br />
    <div class="row mb-3">
      <div class="col-md-3">
        <label>Data Início (dd/mm/aaaa)</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control m-input"
            placeholder="dd/mm/aaaa"
            v-model="filters.date_start"
            v-mask="'##/##/####'"
          />
        </div>
      </div>
      <div class="col-md-3">
        <label>Data Final (dd/mm/aaaa)</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control m-input"
            placeholder="dd/mm/aaaa"
            v-model="filters.date_end"
            v-mask="'##/##/####'"
          />
        </div>
      </div>
      <div class="col-md-4">
        <label>Cliente</label>
        <SelectCustomers
          :selected="filters.customer_id"
          :first="'Selecione um cliente'"
          @change="setFilter('customer_id', $event)"
        />
      </div>
      <div class="col-md-2 d-flex align-items-end">
        <a href data-toggle="modal" @click.prevent="download()" v-if="data.data && data.data.length > 0">
          <button class="btn btn-outline-brand m-btn m-btn--outline" :disabled="downloading">
            <i class="fas fa-download"></i> {{ downloading ? 'Baixando...' : 'Baixar' }}
          </button>
        </a>
      </div>
    </div>

    <div>
      <div class="page-amounts">
        <nav aria-label="...">
          <ul class="pagination pagination-md">
            <li class="page-item" :class="{ selected: amount === 10 }">
              <a @click="amount = 10" class="page-link paginate">10</a>
            </li>
            <li class="page-item" :class="{ selected: amount === 50 }">
              <a @click="amount = 50" class="page-link paginate">50</a>
            </li>
            <li class="page-item" :class="{ selected: amount === 100 }">
              <a @click="amount = 100" class="page-link paginate">100</a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="paginator-info-top m-2">
        <span class="m--font-gray" v-if="data.from"
          >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de {{ data.total }}.</span
        >
        <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
      </div>
    </div>

    <div class="table-responsive">
      <div class="container-table">
        <table class="table table-striped- table-bordered table-hover table-checkable">
          <thead>
            <tr>
              <td nowrap class="text-center align-middle" width="180">Data da extração</td>
              <td nowrap class="text-center align-middle" width="320">Cliente</td>
              <td nowrap class="text-center align-middle" width="180">CNPJ</td>
              <td nowrap class="text-center align-middle" width="180">Faturamento parcial</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(invoice, id) in data.data" :key="id">
              <td class="text-center align-middle">{{ invoice.created_at | datetime }}</td>
              <td class="text-left align-middle">
                {{
                  invoice.customer && invoice.customer.customerable
                    ? invoice.customer.customerable.name ||
                      invoice.customer.customerable.co_name
                    : '-'
                }}
              </td>
              <td class="text-center align-middle">
                {{
                  invoice.customer && invoice.customer.documents
                    ? invoice.customer.documents.value
                    : '-'
                  | cnpj
                }}
              </td>
              <td class="text-right align-middle">{{ invoice.price_total | money }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Paginação -->
    <div class="d-flex justify-content-between align-items-center mt-2" v-if="data.data && data.data.length > 0">
      <div>
        <span class="m--font-gray" v-if="data.from"
          >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de {{ data.total }}.</span
        >
      </div>
      <div>
        <nav aria-label="...">
          <ul class="pagination pagination-md mb-0">
            <li class="page-item" :class="{ disabled: data.current_page == 1 }">
              <a class="page-link paginate" @click.prevent.stop="page = 1"
                ><i class="fal fa-angle-double-left"></i
              ></a>
            </li>
            <li class="page-item" :class="{ disabled: data.current_page == 1 }">
              <a
                class="page-link paginate"
                @click.prevent.stop="page = data.current_page - 1"
                ><i class="fal fa-angle-left"></i
              ></a>
            </li>
            <li
              class="page-item"
              :class="{ disabled: data.current_page == 1 }"
              v-if="data.current_page > 2"
            >
              <a
                class="page-link paginate"
                @click.prevent.stop="page = data.current_page - 2"
              >
                {{ data.current_page - 2 }}</a
              >
            </li>
            <li
              class="page-item"
              :class="{ disabled: data.current_page == 1 }"
              v-if="data.current_page > 1"
            >
              <a
                class="page-link paginate"
                @click.prevent.stop="page = data.current_page - 1"
              >
                {{ data.current_page - 1 }}</a
              >
            </li>
            <li class="page-item selected">
              <a class="page-link paginate"> {{ data.current_page }} </a>
            </li>
            <li
              class="page-item"
              :class="{ disabled: data.current_page == data.last_page }"
              v-if="data.current_page < data.last_page"
            >
              <a
                class="page-link paginate"
                @click.prevent.stop="page = data.current_page + 1"
              >
                {{ data.current_page + 1 }}
              </a>
            </li>
            <li
              class="page-item"
              :class="{ disabled: data.current_page + 1 == data.last_page }"
              v-if="data.current_page + 1 < data.last_page"
            >
              <a
                class="page-link paginate"
                @click.prevent.stop="page = data.current_page + 2"
              >
                {{ data.current_page + 2 }}
              </a>
            </li>
            <li
              class="page-item"
              :class="{ disabled: data.current_page == data.last_page }"
            >
              <a
                class="page-link paginate"
                @click.prevent.stop="page = data.current_page + 1"
                ><i class="fal fa-angle-right"></i
              ></a>
            </li>
            <li
              class="page-item"
              :class="{ disabled: data.current_page == data.last_page }"
            >
              <a class="page-link paginate" @click.prevent.stop="page = data.last_page"
                ><i class="fal fa-angle-double-right"></i
              ></a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { baseApiUrl } from '@/global';
import SelectCustomers from '@/components/forms/SelectCustomers';
import { returnMessageMixin } from '@/mixins/returnMessageMixin.js';

export default {
  name: 'ReportPartialInvoiceConsumption',
  mixins: [returnMessageMixin],
  components: {
    SelectCustomers,
  },
  props: ['start', 'finish', 'createdAt'],
  data() {
    return {
      data: {},
      amount: 50,
      page: 1,
      sortType: 'created_at',
      sortReverse: true,
      downloading: false,
      filters: {
        customer_id: '',
        date_start: '',
        date_end: '',
      },
    };
  },
  methods: {
    setFilter(filterToChange, id) {
      this.filters[filterToChange] = id;
    },
    generate() {
      this.page = 1;
      this.callData();
    },
    convertFilters() {
      return `?page=${this.page}&amount=${this.amount}&sortType=${this.sortType}` +
        `&sortOrder=${this.sortReverse ? 'DESC' : 'ASC'}` +
        `&isPartialInvoice=1` +
        `&customer_id=${this.filters.customer_id || ''}` +
        `&createdAtStart=${this.filters.date_start || ''}` +
        `&createdAtEnd=${this.filters.date_end || ''}`;
    },
    convertFiltersDownload() {
      return `?sortType=${this.sortType}` +
        `&sortOrder=${this.sortReverse ? 'DESC' : 'ASC'}` +
        `&isPartialInvoice=1` +
        `&customer_id=${this.filters.customer_id || ''}` +
        `&createdAtStart=${this.filters.date_start || ''}` +
        `&createdAtEnd=${this.filters.date_end || ''}` +
        `&reportType=general`;
    },
    callData() {
      const timeWindow = 500;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.getFilteredData();
      }, timeWindow);
    },
    getFilteredData() {
      const url = `${baseApiUrl}/v1/invoice/search/${this.convertFilters()}`;

      axios
        .get(url)
        .then((res) => {
          this.data = res.data;
          this.$emit('updateLoading');
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    download() {
      if (!this.data.data || !this.data.data.length || this.downloading) {
        return;
      }

      this.downloading = true;
      const url = `${baseApiUrl}/v1/invoice/download-report-parcial${this.convertFiltersDownload()}`;

      axios
        .get(url)
        .then((res) => {
          const rows = res.data;
          if (!rows || !rows.length) {
            return;
          }

          let csvContent = '\uFEFF';
          csvContent += Object.keys(rows[0]).join(';') + '\n';
          rows.forEach((row) => {
            csvContent += Object.values(row).map(v => v !== null && v !== undefined ? v : '').join(';') + '\n';
          });

          const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
          const link = document.createElement('a');
          link.setAttribute('href', URL.createObjectURL(blob));
          link.setAttribute('download', 'relatorio_consumo_fatura_parcial.csv');
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        })
        .finally(() => {
          this.downloading = false;
        });
    },
  },
  watch: {
    amount() {
      if (this.page === 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
    'filters.customer_id'() {
      this.page = 1;
      this.callData();
    },
  },
};
</script>
